import React from 'react';
import { Link } from '../../../env';
const Contactus = ({ handleMain }) => {
    return (
        <div className='w-full relative min-h-screen bg-[#283747] overflow-hidden'>
            <div className='w-full absolute top-0 left-0 z-20'>
                <div className='w-full sticky top-0 left-0 z-20 flex justify-end py-5 px-6'>
                    <a href='/'><img src={`${Link}assets/Icons/return.png`} className='w-[50px] rounded-full p-2 border-2 border-white bg-[#1a5276]' onClick={handleMain} /></a>
                </div>
            </div>
            <div className='w-full absolute top-24 left-0'>
                <div className='w-full px-6'>
                    <div className='w-full flex items-center h-[60px] rounded-xl bg-[rgba(44,83,121,0.4)] border-[1px] border-[rgba(255,255,255,0.5)]'>
                        <div className=''>
                            <img src={`${Link}assets/Icons/user-icon.png`} className='w-[20px] mx-5' />
                        </div>
                        <div className='flex-1 h-full'>
                            <input className='w-full text-white h-full flex bg-transparent focus:outline-none items-center' placeholder='Enter Your Full Name . . .' />
                        </div>
                    </div>
                    <div className='w-full flex items-center h-[60px] mt-3 rounded-xl bg-[rgba(44,83,121,0.4)] border-[1px] border-[rgba(255,255,255,0.5)]'>
                        <div className=''>
                            <img src={`${Link}assets/Icons/eaddress.png`} className='w-[20px] mx-5' />
                        </div>
                        <div className='flex-1 h-full'>
                            <input className='w-full text-white h-full flex bg-transparent focus:outline-none items-center' placeholder='Enter Your e-mail . . .' />
                        </div>
                    </div>
                    <div className='w-full mt-3'>
                        <textarea placeholder='Message ...' className='w-full text-white focus:outline-none p-3 rounded-xl resize-none h-[200px] bg-[rgba(44,83,121,0.4)] border-[1px] border-[rgba(255,255,255,0.5)]'></textarea>
                    </div>
                    <button className='w-full flex justify-center items-center rounded-xl mt-3 h-[50px] bg-[#083389] border-[1px] border-[rgba(255,255,255,0.5)]'>
                        <div>
                            <img className='w-[30px]' src={`${Link}assets/Icons/submit.png`} />
                        </div>
                        <div className='mx-3 text-white text-sm poppins-medium'>
                            Send Message . . .
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Contactus;
